// consoleAccess.js — Fase 1 pos-simulado Savassi (2026-10-28). Consumidor do
// contrato de consoles do participante externo, calculado no backend
// (src/backend/rbac/externalParticipantAccess.js) e entregue em
// /api/auth/me como user.consoleAccess. Sem contrato (conta institucional),
// nada muda. Ocultar/negar e conveniencia de interface; a autorizacao real
// continua nas rotas.
export const CONSOLE_MODES = Object.freeze({ FULL: 'full', VIEW: 'view', DENIED: 'denied', SHOWCASE: 'showcase' });

// Sala de demonstracao: visitante percorre os consoles sem comandar. Paginas
// reservadas seguem negadas e as nao operacionais nao mudam.
const SHOWCASE_DENIED_PAGES = new Set(['intelligenceofficer', 'godmode']);
const SHOWCASE_UNTOUCHED_PAGES = new Set(['accountmanager', 'academiareacta', 'library', 'chemicaldatabase', 'soundcontrolroom']);

function normalizePageKey(page) {
    return String(page || '').toLowerCase().replace(/[^a-z0-9]/g, '');
}

// Lista e credencial vem do backend (user.showcase, em /api/auth/me).
export function showcaseRooms(user) {
    return user?.showcase?.rooms || [];
}

export function isShowcaseRoom(user, operationId) {
    const id = String(operationId || '').trim().toUpperCase();
    return showcaseRooms(user).some((room) => room.operationId === id);
}

export function isShowcaseVisitor(user, operationId) {
    return isShowcaseRoom(user, operationId) && user?.showcase?.editor !== true;
}

export function consolePageMode(user, page, operationId = null) {
    if (isShowcaseVisitor(user, operationId)) {
        const key = normalizePageKey(page);
        if (SHOWCASE_DENIED_PAGES.has(key)) return CONSOLE_MODES.DENIED;
        if (!SHOWCASE_UNTOUCHED_PAGES.has(key)) return CONSOLE_MODES.SHOWCASE;
    }
    const access = user?.consoleAccess;
    if (!access) return CONSOLE_MODES.FULL;
    return access.pages?.[normalizePageKey(page)] || access.defaultMode || CONSOLE_MODES.DENIED;
}

export default { CONSOLE_MODES, consolePageMode, showcaseRooms, isShowcaseRoom, isShowcaseVisitor };
